
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useWebsiteCategories } from "@/hooks/useWebsiteCategories";
import { WebsiteCategory } from "@/types/websiteCategories";
import { IconSelector } from "./IconSelector";

interface CreateWebsiteCategoryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  categories: WebsiteCategory[];
}


export const CreateWebsiteCategoryDialog = ({ 
  open, 
  onOpenChange, 
  categories 
}: CreateWebsiteCategoryDialogProps) => {
  const { createCategory } = useWebsiteCategories();
  const [formData, setFormData] = useState({
    name: '',
    icon: 'Globe'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.name.trim()) return;

    setIsSubmitting(true);
    try {
      await createCategory({
        name: formData.name.trim(),
        icon: formData.icon,
        color: '#6B7280'
      });

      // Reset form
      setFormData({
        name: '',
        icon: 'Globe'
      });
      
      onOpenChange(false);
    } catch (error) {
      // Error is handled in the hook
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Create Website Category</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="name">Name *</Label>
            <Input
              id="name"
              value={formData.name}
              onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
              placeholder="Enter category name"
              required
            />
          </div>

          <IconSelector 
            value={formData.icon}
            onChange={(icon) => setFormData(prev => ({ ...prev, icon }))}
          />

          <div className="flex justify-end space-x-2 pt-4">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit" disabled={!formData.name.trim() || isSubmitting}>
              {isSubmitting ? 'Creating...' : 'Create Category'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
